import Image from 'next/legacy/image';
import { ReactElement } from 'react';

import { Wrapper } from './styles';
import { CalmSleepLogoColor, CalmSleepLogoProps } from './types';

const ASPECT_RATIO = 216 / 84;

const CalmSleepLogo = ({
	className,
	height = 40,
	color = CalmSleepLogoColor.White,
	loader,
	'aria-label': ariaLabel = 'Calm Sleep Logo - Link to Homepage',
}: CalmSleepLogoProps): ReactElement => {
	const width = height * ASPECT_RATIO;
	const src =
		color === CalmSleepLogoColor.White
			? '/_n/images/calm-sleep-logo.svg'
			: '/_n/images/calm-sleep-logo-gradient.svg';
	return (
		<Wrapper className={className} $height={height}>
			<Image
				width={width}
				height={height}
				src={src}
				loader={loader}
				alt="Calm Sleep logo"
				unoptimized
				aria-label={ariaLabel}
			/>
		</Wrapper>
	);
};
export default CalmSleepLogo;
